import React, { Component } from 'react'
import { connect } from 'react-redux'
import styled, { css, injectGlobal } from 'styled-components'
import { Link, withRouter } from 'react-router-dom'
import { rgba } from 'polished'
import { filter } from 'lodash'

import { updateSettings } from '../../settings'
import { fetchChapters, getChapters } from '../../modules/Chapters/redux'
import { fetchData } from '../../api'

import { media } from '../../styles/utils'
import { green, greenSecondary } from '../../styles/colors'
import { hoverState, padding } from '../../styles/global'
import { data } from './data'

import Logo from 'svg-react-loader?name=Icon!../../assets/images/aesop-logo.svg'

class Contents extends Component {

    state = {

    }

    static fetchData(store, match) {
        return store.dispatch(fetchChapters()); 
    }

    componentDidMount = () => {
        const { updateSettings, fetchChapters } = this.props;

        fetchChapters()

        updateSettings({
            pageTitle: 'Contents'
        })

        // fetchData('wpapi/testAuth')
        //     .then(response => {
        //         console.log(response)
        //         updateSettings({
        //             pageTitle: 'Authenticated'
        //         })
        //     })

    }
    
    renderSections = () => {
        const { chapters } = this.props;

        //console.log('chapters',chapters);

        if (chapters.data) {
            return chapters.data.map((section, i) => {

                if (section.type==='parent') {

                    // get child pages related to current section/parent page

                    const children = filter(this.props.chapters.data, { parent_id: section.id })

                    const chapters = children.map((chapter, i) => {
                        return (
                            <ChapterLink
                                key={i}
                                to={`/chapter/${section.slug}/${chapter.slug}`}
                            >
                                {chapter.title}
                            </ChapterLink>
                        )
                    })
    
                    if (children.length) {
                        return (
                            <Section
                                key={i}
                            >
                                <SectionLink
                                    to={`/chapter/${section.slug}/${children[0].slug}`}                                    
                                    hasChapters={true}
                                >
                                    {section.title}     
                                </SectionLink>
                            
                                <Chapters>
                                    {chapters}
                                </Chapters>
                            </Section>
                        )
                    }
                }
            })
       }   
    }

    render() {
        return (
            <Container>
                <Sections>
                    {/* <SectionLink
                        to={'/'}
                    >
                        Contents    
                    </SectionLink> */}

                    {this.renderSections()}
                </Sections>

                <MobileContact>
                    <Help>
                 	For assistance with this document please <a href="mailto:Giselle.Hernandez@aesop.com">contact</a> Giselle Hernandez, Retail Design Project Manager or email <a href="mailto:store.design@aesop.com">store.design@aesop.com</a>
		    </Help>

                    <AesopLogo/>
                </MobileContact>
            </Container>
        )
    }
}

const Container = styled.div`
    overflow: hidden;
    flex: 1;
    width: 100%;
    height: calc(100vh - 65px); 
    overflow-y: scroll;
`

const Sections = styled.div`
    display: flex;
    flex-direction: column;
    ${padding}

    &:first-child {
        padding-top: 12px;
    }

    ${media.phone`
        align-items: flex-end;
        text-align: right;
    `}

    > :first-child {
        margin-bottom: 17px;
    }
`

const contentsLink = css`
    font-family: 'Suisse';  
    font-size: 24px;
    color: #000000;

    ${media.phone`
        font-size: 16px;
    `}
`

const SectionLink = styled(Link)`
    width: 510px;
    ${contentsLink}
    text-transform: uppercase;

    ${props => {
        if (!props.chapters) return css`
            cursor: pointer;
            ${hoverState}
        `
    }}
`

const Section = styled.div`
    display: flex;
    margin-top: 8px;

    &:first-of-type {
        margin-top: 70px;
    }

    ${media.phone`
        flex-direction: column;

        &:first-of-type {
            margin-top: 18px;
        }
    `}

    > ${SectionLink} {
        width: auto;
        flex: 0 1 510px;

        ${media.tablet`
            flex: 0 1 240px;
        `}

        ${media.phone`
            flex: 0;
        `}
    }
`

const Chapters = styled.div`
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    flex: 1;

    ${media.phone`
        &:last-child {
            margin-bottom: 0;
        }
    `}
`

const ChapterLink = styled(Link)`
    ${contentsLink}
    cursor: pointer;
    ${hoverState}
`

// Mobile footer


const MobileContact = styled.div`
    display: none;
    flex-direction: column;
    border-top: 1px solid black;
    margin-top: 24px;

    ${media.phone`
        display: flex;
    `}
`

const Help = styled.div`
    font-size: 12px;
    color: #000000;
    text-align: right;
    margin-top: 10px;
    padding: 0 10px;

    a {
        text-decoration: underline;
    }
`;

const AesopLogo = styled(Logo)`
    align-self: flex-end;
    margin-top: 24px;
    padding-right: 13px;
`;



const mapDispatchToProps = dispatch => ({
    updateSettings(setting) {
        dispatch(updateSettings(setting))
    },
    fetchChapters() {
        dispatch(fetchChapters())
    },
})

const mapStateToProps = (state, props) => ({
    chapters: getChapters(state),
})

export default connect(mapStateToProps, mapDispatchToProps)(Contents);



// WEBPACK FOOTER //
// ./client/modules/Contents/Contents.js